module.exports = __webpack_public_path__ + "img/news-detail.966b23a3.png";